import type { Status } from '@xleddyl/types'
import { markRaw } from 'vue'
import { toast } from 'vue-sonner'
import Toast from '~/components/core/Toast.vue'

export type NotificationProps = {
   title: string
   description?: string | string[]
   type?: Status
}

export default defineNuxtPlugin(() => {
   return {
      provide: {
         notification: {
            add: (props: NotificationProps) => {
               toast.custom(markRaw(Toast), {
                  componentProps: props,
                  class: 'right-0 w-full max-w-[350px]',
                  dismissible: false,
                  position: 'bottom-right',
               })
            },
         },
      },
   }
})
